<template>
    <div class="login_wrap">
        <comp-header></comp-header>
        <p>手机验证码登录</p>
        <form @submit.prevent.enter="submit" method="post" novalidate="true" autocomplete="off">
            <ul>
                <li>
                    <input id="mobile" v-model="mobile" type="text" name="mobile" placeholder="输入手机号码" @blur="checkForm(1)">
                </li>
                <li  class="li_error">{{ errors[0] }}</li>
                <li>
                    <input id="verify" v-model="verify" type="text" name="verify" maxlength="6" placeholder="输入验证码" @blur="checkForm">
                    <a  @click.prevent="clickSendVerify" class="btn_send" :class="{ disabled:isActive }">{{showBtnText}}</a>
                </li>
                <li class="li_error">{{ errors[1] }}</li>
                <li><input type="submit" value="登录" class="btn_login"></li>
            </ul>
        </form>
        <p class="other">
            其他方式登录
        </p>
        <div>
            <a class="btn_wechat" @click="wechatLogin"></a>
            <a class="btn_qq" @click="qqLogin"></a>
        </div>
        <div class="agree">
            <label for="ckbagree">
              <input type="checkbox" @click="changeAgree"  v-model="agree" id="ckbagree" /> 登录即同意
            </label>
            <a target="_blank" href="http://www.ijinshan.com/protocol/memberServerUser.shtml">《会员服务使用协议》</a>
        </div>
    </div>
</template>

<script>
    import CompHeader from '@/layout/Header.vue'
    import {mapActions,mapGetters} from 'vuex';
    import {userLogin,winClose,urlList} from '@/utils/client';
    import { setSpread } from '@/utils/cache'

    export default {
        name: "UserLogin",
        data() {
            return {
                errors: [],
                mobile: null,
                verify: null,
                send: false,
                isActive: false,
                count: -1,//发送验证码按钮文本
                timer: null,
                agree:true
            }
        },
        computed: {
            ...mapGetters(["token","userInfo"]),
            showBtnText() {
                switch (this.count) {
                    case -1:
                        return '获取验证码';
                    case -2:
                        return '发送中...';
                    case -3:
                        return '重发送验证码';
                    default:
                        return `${this.count}s后重试`;
                }
            },
            validCode() {
                const re = /^\d{6}$/;
                return re.test(this.verify);
            },
            validPhone() {
                const mobileRule = /(?:^1[3456789]|^9[28])\d{9}$/;
                return mobileRule.test(this.mobile);
            }
        },
        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
        methods: {
            ...mapActions(["sendVerify", "login"]),
            clickSendVerify() {
                if (this.checkForm(1) && !this.send) {
                    this.count = -2;
                    this.send = true;
                    this.sendVerify({mobile: this.mobile})
                        .then((data) => {
                            this.countDown();
                        }).catch(() => {
                        this.$toast("发送异常，请重新获取");
                        this.reset();
                    });
                }
            },
            countDown() {
                let count = 60;
                this.timer = setInterval(() => {
                    if (count == 0) {
                        this.reset();
                        return;
                    }
                    this.count = (count--);
                    this.isActive = true;
                }, 1000);
            },
            reset() {
                this.send = false;
                this.isActive = false;
                clearInterval(this.timer);
                this.count = -3;
            },
            checkForm(type) {
                this.errors = [];
                if(!this.agree){
                    this.$toast("请同意会员服务使用协议");
                    return false;
                }
                if (!this.mobile) {
                    this.errors[0]="请输入手机号";
                    return false;
                } else if (!this.validPhone) {
                    this.errors[0]='请输入正确手机号';
                    return false;
                }
                if (type == 1) {
                    return true;
                }
                if (!this.verify) {
                    this.errors[1]='请输入验证码';
                    return false;
                } else if (!this.validCode) {
                    this.errors[1]='请输入6位数字';
                    return false;
                }
                return true;

            },
            submit(){
                if(this.checkForm()){
                    if (!this.errors.length) {
                        this.login({
                            tel: this.mobile,
                            code: this.verify,
                        })
                            .then((data) => {
                                const ret = data.resp_common.ret;
                                if (ret == 0) {
                                    setSpread()
                                    winClose({token:this.token, open_id:this.userInfo.open_id, type:3})
                                    // this.$router.push({path: "/"})
                                } else {
                                    if (ret == 3001002) {
                                        this.$set(this.errors,1,"验证码错误");
                                    } else {
                                        console.error(ret)
                                    }
                                }
                            })
                            .catch((e) => {
                                console.error(e)
                            });
                    }
                }
            },
            qqLogin(){
                userLogin({url:urlList.qq,width:1000,height:500})
            },
            wechatLogin(){
                userLogin({url:urlList.wechat,width:1000,height:500})
            },
            changeAgree(){
                this.agree=!this.agree;
            }

        },
        components:{
            CompHeader
        }

    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/mixins.scss";
    .login_wrap{
        position: relative;
        p{
            color: #636D78;
            font-size: 22px;
            padding-left: 38px;
            margin-bottom: 20px;
            margin-top: 47px;

            &.other{
                font-size: 16px;
                margin-bottom: 16px;
                margin-top: 30px;
            }
        }
        margin: 0 auto;
        width: 320px;
        height: 420px;
        border:1px solid #FAC936;
        box-shadow: 0px 0px 7px 4px #ecebeb;
        box-sizing: border-box;
        ul{
            width: 245px;
            margin:0 auto;
        }
        li{
            height: 43px;
            &.li_error {
                height: 16px;
                color: #FF3F3F;
                font-size: 12px;
                margin-top: 2px;
            }
        }
        input[type='text']{
            height: 40px;
            width: 244px;
            border: solid 1px #fff;
            border-bottom-color:#636D78;
            outline: none;
            box-shadow: none;
            &::selection{
                background: #2593ff;
                color: #fff;
            }
        }
        #verify{
            width: 123px;
        }
    }
    .btn_send {
        display: inline-block;
        @include btn_class(
                $width: 98px,
                $height: 36px,
                $color: #636D78,
                $line-height: 36px,
                $border-radius:0px,
                $background:#fff,
                $font-size: 12px,
                $border:solid 1px #636D78
         );
        margin-left: 20px;
    }
    .btn_login{
        margin-top: 10px;
        outline: none;
        @include btn_class(
                $width: 244px,
                $height: 38px,
                $line-height: 38px,
                $font-size: 16px
        );
    }

    .disabled {
        border-color: #DDD;
        background-color: #DDD;
        color: #fff;
        cursor: auto;
    }
    @mixin wechatqq{
        display: inline-block;
        @include icon_bg;
        width: 48px;
        height: 48px;
        cursor: pointer;
    }
    .btn_wechat{
        @include wechatqq;
          background-position: -457px -186px;
          &:hover{
              background-position: -505px -186px;
          }
        margin-left: 36px;
        margin-right: 16px;

    }
    .btn_qq{
        @include wechatqq;
        background-position: -458px -243px;
        &:hover{
            background-position: -506px -243px;
        }
    }
    .agree {
        label , input{
            cursor: pointer;
        }
        input {
            vertical-align: -2px;
        }
        margin-top: 10px;
        margin-left: 36px;
        font-size: 12px;
    }
</style>